import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { StaticTemplateModule } from '~/templates/static/modules/staticTemplateModule';
import { StaticTemplateComponent } from '~/templates/static/static';
import { GuestGuard } from '~/guards/guestGuard';

export const ROUTES: Routes = [
    {
        path: '',
        component: StaticTemplateComponent,
        children: [
            {
                path: '',
                data: { title: 'Homepage' },
                loadChildren: () => {
                    if (process.env.FEATURE_HOMEPAGE_ENABLED === "true") {
                        return import('src/app/pages/static/home/modules/homeModule').then(m => m.HomePageModule)
                    }

                    return import('src/app/pages/static/static/modules/staticModule').then(m => m.StaticPageModule)
                }
            },
            {
                path: 'terms',
                redirectTo: 'https://info.awth.com.au/terms-of-use'
            },
            {
                path: 'privacy',
                redirectTo: 'https://info.awth.com.au/privacy-policy'
            },
            {
                path: 'agreement',
                redirectTo: 'https://info.awth.com.au/user-service-agreement'
            },
            {
                path: 'contact-us',
                data: { title: 'Contact Us' },
                loadChildren: () => import('src/app/pages/static/contactUs/modules/contactUsRouteModule').then(m => m.ContactUsPageRouteModule)
            },
            {
                path: 'faqs',
                data: { title: 'FAQs' },
                loadChildren: () => import('src/app/pages/static/faqs/modules/faqsRouteModule').then(m => m.FaqsPageRouteModule)
            },
            {
                path: 'industry',
                data: { title: 'Industry' },
                loadChildren: () => import('src/app/pages/static/industry/modules/industryModule').then(m => m.IndustryModule)
            },
            {
                path: 'training',
                data: { title: 'AWTH Resources' },
                loadChildren: () => import('src/app/pages/static/training/modules/trainingRouteModule').then(m => m.TrainingPageRouteModule)
            },
            {
                canActivate: [ GuestGuard ],
                path: 'subscribe',
                data: { title: 'Subscribe' },
                loadChildren: () => import('src/app/pages/static/subscribe/modules/subscribeRouteModule').then(m => m.SubscribePageRouteModule)
            },
            {
                path: 'profile/:entityId',
                data: { title: 'Profile' },
                loadChildren: () => import('src/app/pages/login/profile/modules/profilePageModule').then(m => m.ProfilePageModule)
            },
            {
                path: '404',
                data: { title: 'Page Not Found' },
                loadChildren: () => import('src/app/pages/login/pageNotFound/modules/pageNotFoundModule').then(m => m.PageNotFoundPageModule)
            },
            {
                path: 'home',
                redirectTo: ''
            },
            {
                path: 'homepage',
                redirectTo: ''
            },
            {
                path: '**',
                redirectTo: '404'
            }
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(ROUTES),
        StaticTemplateModule
    ],
})

export class StaticPagesModule {
}
